import { useState, useCallback } from 'react';

export enum CohortCompareTableType {
  Top = 'Top 100',
  Bottom = 'Bottom 100',
}

// hook to manage the state of the cohort comparison table types.
// currently kobol only supports top & bottom, adjust as needed for more table types.
export default () => {
  const [compareTableKey, setCompareTableKey] = useState<string>(
    CohortCompareTableType.Top,
  );

  const onSelect = useCallback((key) => {
    setCompareTableKey(key);
  }, []);

  const compareTableOptions = [
    {
      text: CohortCompareTableType.Top,
      value: CohortCompareTableType.Top,
    },
    {
      text: CohortCompareTableType.Bottom,
      value: CohortCompareTableType.Bottom,
    },
  ];

  return { compareTableOptions, compareTableKey, onSelect };
};
